<template>
  <div class="modal-overlay" style="">
    <div class="modal-content">
      <!-- Step 1: Profile -->
      <div v-if="registrationStep === 1">
        <h2>Create Your Profile</h2>
        <div class="form-group">
          <label>Full Name</label>
          <input v-model="profileFullName" type="text" placeholder="John Doe" />
        </div>
        <div class="form-group">
          <label>Email</label>
          <input v-model="profileEmail" type="email" placeholder="johndoe@example.com" />
        </div>
        <div class="form-group">
          <label>Password</label>
          <input
            v-model="profilePassword"
            :type="showPassword ? 'text' : 'password'"
            placeholder="Enter a password"
          />
          <button type="button" @click="togglePassword">
            {{ showPassword ? 'Hide' : 'Show' }}
          </button>
        </div>
        <div class="form-group">
          <label>Confirm Password</label>
          <input
            v-model="profileConfirmPassword"
            :type="showConfirmPassword ? 'text' : 'password'"
            placeholder="Confirm your password"
          />
          <button type="button" @click="toggleConfirmPassword">
            {{ showConfirmPassword ? 'Hide' : 'Show' }}
          </button>
        </div>
        <div class="form-group">
          <label>Zip Code</label>
          <input v-model="profileZipCode" type="text" placeholder="12345" />
        </div>
        <div class="form-group">
          <label>Skill Level</label>
          <select v-model="profileSkillLevel">
            <option disabled value="">Select your skill level</option>
            <option>Beginner</option>
            <option>Intermediate</option>
            <option>Expert</option>
            <option>Service Technician</option>
          </select>
        </div>
        <div v-if="profileSkillLevel === 'Service Technician'" class="form-group">
          <label>Occupation</label>
          <input
            v-model="profileOccupation"
            type="text"
            placeholder="HVAC Technician, Electrician, etc."
          />
        </div>
        <div v-if="profileSkillLevel === 'Service Technician'" class="form-group">
          <label>Years of Experience</label>
          <input v-model="profileYearsOfExperience" type="text" placeholder="e.g., 5" />
        </div>
        <button class="primary-button" @click="goToNextStep">Next</button>
      </div>

      <!-- Step 2: Questionnaire -->
      <div v-else-if="registrationStep === 2">
        <h2>Questionnaire</h2>
        <div class="scroll-box">

         <!-- Question 1 -->
         <div class="form-group">
           <label><strong>What would you like Pocket Journeyman to accomplish for you?</strong></label>
           <div>
             <label>
               <input type="radio" v-model="questionnaire.accomplish" value="fix_basic">
               I want to fix basic issues to prevent nuisance service calls and save money.
               <span>(Estimated savings per repair: $50–$150)</span>
            </label>
           </div>
           <div>
             <label>
               <input type="radio" v-model="questionnaire.accomplish" value="handle_routine">
               I want to handle routine maintenance and minor repairs on my own.
               <span>(Estimated savings per repair: $100–$300)</span>
             </label>
           </div>
           <div>
             <label>
               <input type="radio" v-model="questionnaire.accomplish" value="manage_common">
               I want to manage common repair tasks with some expert guidance.
               <span>(Estimated savings per repair: $200–$500)</span>
             </label>
           </div>
           <div>
             <label>
               <input type="radio" v-model="questionnaire.accomplish" value="tackle_challenging">
               I want to tackle more challenging issues with detailed step-by-step instructions.
               <span>(Estimated savings per repair: $300–$700)</span>
            </label>
          </div>
          <div>
            <label>
              <input type="radio" v-model="questionnaire.accomplish" value="solve_all">
              I want to solve all problems myself even the complex ones.
              <span>(Estimated savings per repair: $500–$1500)</span>
            </label>
          </div>
        </div>

        <!-- Question 2 -->
        <div class="form-group">
          <label><strong>How much experience do you have with tools/power tools?</strong></label>
          <div>
            <label>
              <input type="radio" v-model="questionnaire.toolExperience" value="no_experience">
              No experience.
            </label>
          </div>
          <div>
            <label>
              <input type="radio" v-model="questionnaire.toolExperience" value="beginner">
              Beginner (limited use).
            </label>
          </div>
          <div>
            <label>
              <input type="radio" v-model="questionnaire.toolExperience" value="intermediate">
              Intermediate (some familiarity).
            </label>
          </div>
          <div>
            <label>
              <input type="radio" v-model="questionnaire.toolExperience" value="advanced">
              Advanced (comfortable with power tools).
            </label>
          </div>
          <div>
            <label>
              <input type="radio" v-model="questionnaire.toolExperience" value="expert">
              Expert (extensive/professional experience).
           </label>
        </div>
      </div>

      <!-- Question 3 -->
      <div class="form-group">
        <label><strong>What tools do you currently have access to?</strong></label>
      <div>
        <label>
          <input type="radio" v-model="questionnaire.toolsAccess" value="basic_hand_tools">
          Only basic hand tools (hammer, screwdriver, etc.).
        </label>
      </div>
      <div>
        <label>
          <input type="radio" v-model="questionnaire.toolsAccess" value="few_power_tools">
          A few basic power tools (drill, saw, etc.).
        </label>
      </div>
      <div>
        <label>
          <input type="radio" v-model="questionnaire.toolsAccess" value="standard_diy_toolkit">
          A standard DIY toolkit.
        </label>
      </div>
      <div>
        <label>
          <input type="radio" v-model="questionnaire.toolsAccess" value="well_equipped_workshop">
          A well-equipped home workshop.
        </label>
      </div>
      <div>
        <label>
          <input type="radio" v-model="questionnaire.toolsAccess" value="professional_grade">
          Professional-grade or commercial tools.
        </label>
      </div>
    </div>
  </div>

  <button class="secondary-button" @click="goToPreviousStep">Back</button>
  <button class="primary-button" @click="goToNextStep">Next</button>
</div>


      <!-- Step 3: Validation and Payment -->
      <div v-else-if="registrationStep === 3">
        <h2>Validation and Payment</h2>
      
        <!-- Premium Subscription Option -->
        <div class="form-group">
           <label>Subscription Plan</label>
           <select v-model="subscriptionPlan">
           <option disabled value="">Select a plan</option>
           <option value="Premium">$9.99/month Premium Subscription</option>
         </select>
        </div>
  
        <!-- Promo Code Section -->
        <div class="form-group">
          <label>Promo Code</label>
          <input v-model="promoCode" type="text" placeholder="Enter promo code" />
        </div>


        <div class="form-group">
          <label>Name on Card</label>
          <input v-model="cardName" type="text" placeholder="Name as it appears on card" />
        </div>
        
        <div class="form-group">
          <label>Credit Card Information</label>
          <div id="card-element"></div>
        </div>
        <div id="card-errors" role="alert"></div>
        <button class="secondary-button" @click="goToPreviousStep">Back</button>
        <button class="primary-button" @click="validateAndSubmitRegistration">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";

export default {
  name: "Registration",
  data() {
    return {
      // Modal control and registration step
      showRegistrationModal: true,
      registrationStep: 1,
      // Profile fields
      profileFullName: "",
      profileEmail: "",
      profilePassword: "",
      profileConfirmPassword: "",
      showPassword: false,
      showConfirmPassword: false,
      profileZipCode: "",
      profileSkillLevel: "",
      profileOccupation: "",
      profileYearsOfExperience: "",
      // Questionnaire fields
      questionnaire: {
        accomplish: "",
        toolExperience: "",
        toolsAccess: ""
      },
      // Payment fields
      cardName: "",
      stripe: null,
      cardElement: null,
      stripeInitialized: false,
      paymentMethodId: null,
      errorMessage: "",
      subscriptionPlan: "Premium", // Default plan, can be changed based on user selection
      promoCode: ""
    };
  },
  methods: {
    goToNextStep() {
      // Optionally add step-specific validation here before moving forward.
      if (this.registrationStep < 3) {
        this.registrationStep++;
      }
    },
    goToPreviousStep() {
      if (this.registrationStep > 1) {
        this.registrationStep--;
      }
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    async initializeStripe() {
      if (this.stripeInitialized) return;
      try {
        // Replace with your actual Stripe public key.
        this.stripe = await loadStripe(
          "pk_live_51QwcN4JwJ2HmDKTaIf9pPdXkJJ94ZsbTpqI0hssSjL5KnQgm7ti40b2aCrNHTdHyeE7DPpyTXuuuvBqQmP9Dk25Q00ZEcRh9n7"
        );
        const elements = this.stripe.elements();
        this.cardElement = elements.create("card");
        this.cardElement.mount("#card-element");
        this.cardElement.on("change", (event) => {
          const displayError = document.getElementById("card-errors");
          if (event.error) {
            displayError.textContent = event.error.message;
          } else {
            displayError.textContent = "";
          }
        });
        this.stripeInitialized = true;
      } catch (error) {
        console.error("Stripe initialization error:", error);
      }
    },
    async validateAndSubmitRegistration() {
      // Basic Profile validation
      if (
        !this.profileFullName ||
        !this.profileEmail ||
        !this.profilePassword ||
        !this.profileConfirmPassword ||
        !this.profileZipCode 
      ) {
        this.errorMessage = "Please fill out all required profile fields.";
        alert(this.errorMessage);
        return;
      }
      if (this.profilePassword !== this.profileConfirmPassword) {
        this.errorMessage = "Passwords do not match.";
        alert(this.errorMessage);
        return;
      }

      // Check if the promo code "AdamRules" is applied
      if (this.promoCode === "AdamRules") {
       console.log("Promo code applied; bypassing credit card requirement.");
       // Bypass Stripe payment method creation
       this.paymentMethodId = null; // or assign a placeholder value if needed
     } else {

       // Create Payment Method using Stripe
       const { paymentMethod, error } = await this.stripe.createPaymentMethod({
         type: "card",
         card: this.cardElement,
         billing_details: {
           name: this.cardName,
           address: { postal_code: this.billingZipCode }
         }
       });

       if (error) {
         this.errorMessage = error.message;
         alert(this.errorMessage);
         return;
       }

      console.log("Payment Method created:", paymentMethod);

      this.paymentMethodId = paymentMethod.id;
      }

      // If not promo code is applied, call the subscription API first
      if (this.promoCode !== "AdamRules") {
        //Build the subscription data object
        const subscriptionData = {
          paymentMethodId: this.paymentMethodId,
          cardName: this.cardName,
          email: this.profileEmail,
        };
      
        //call the subscription API endpoint
        try {
          const subscriptionResponse = await fetch("https://www.pocketjourneyman.app/api/subscription", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify(subscriptionData)
          });
        
          if (!subscriptionResponse.ok) {
            const errorData = await subscriptionResponse.json();
            alert(errorData.error || "Subscription failed.");
            return;
          } else {
            const subscriptionResult = await subscriptionResponse.json();
            console.log("Subscription successful, backend response:", subscriptionResult);
          }
        } catch (error) {
          console.error("Error during subscription:", error);
          alert("Error during subscription.");
          return;
        }
      }
        

      // Here you would combine the profile, questionnaire, and payment data and send it to your registration API.
      const registrationData = {
        fullName: this.profileFullName,
        email: this.profileEmail,
        password: this.profilePassword, //send securely over HTTPS
        zipCode: this.profileZipCode,
        skillLevel: this.profileSkillLevel,
        occupation: this.profileOccupation,
        yearsOfExperience: this.profileYearsOfExperience,
        questionnaire: this.questionnaire,
        subscriptionPlan: this.subscriptionPlan,
        paymentMethodId: this.paymentMethodId
      };

      console.log("Registration data:", registrationData);
      console.log("Payment Method ID:", this.paymentMethodId);
      console.log("Subscription Plan:", this.subscriptionPlan);

       // Send the registration data to the backend
       try {
         const response = await fetch("https://www.pocketjourneyman.app/api/register", {
           method: "POST",
           headers: { "Content-Type": "application/json" },
           credentials: "include", // ensures cookies are sent and received
           body: JSON.stringify(registrationData)
         });

         if (!response.ok) {
            const errorData = await response.json();
            alert(errorData.error || "Registration failed.");
            return;
         }

         const data = await response.json();
         console.log("Registration successful, backend response:", data);
         alert("Registration successful!");

        
         // Optionally, update parent state (via an event) if needed.
         this.$emit("registered", data.user);
         this.showRegistrationModal = false;

      } catch (err) {
        console.error("Error during registration:", err);
        alert("An error occurred during registration.");
      }
    },
    closeRegistrationModal() {
      this.showRegistrationModal = false;
    }
  },
  watch: {
    registrationStep(newStep) {
      // When the user reaches the payment step, initialize Stripe.
      if (newStep === 3) {
        this.$nextTick(() => {
          this.initializeStripe();
        });
      }
    }
  }
};
</script>

<style scoped>
/* These styles match your app’s color and font scheme. */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  text-align: center;
  font-family: Helvetica, sans-serif;
  color: #333;
}
.form-group {
  margin-bottom: 15px;
  text-align: left;
}
.form-group label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
}
input[type="text"],
input[type="email"],
input[type="password"],
select,
textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  background: #fff;
}
.primary-button {
  background: #f4a261;
  color: #000;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
  margin: 5px;
}
.primary-button:hover {
  background: #e0884d;
}
.secondary-button {
  background: #fff;
  color: #f4a261;
  border: 1px solid #f4a261;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
  margin: 5px;
}
.secondary-button:hover {
  background: #f4a261;
  color: #000;
}
.scroll-box {
  max-height: 400px;  /* Adjust the height as needed */
  overflow-y: auto;
  padding-right: 10px; /* Optional, to account for scrollbar */
  border: 1px solid #ccc; /* Optional, for visual separation */
  margin-bottom: 20px;
}

/* Optional: Make all labels bold if needed */
.form-group label {
  font-weight: bold;
}

</style>
